/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'list',
        'headingLink',
        'heading',
        'headingAll',
        'listItem',
        'listItemSx',
        'badge',
        'wrapperStyles',
        'defaultListStyle',
        'bgColorPadding',
        'link'
    ],
    baseStyle: {
        container: {
            color: 'white'
        },
        list: {
            fontSize: 'webMd',
            spacing: 3
        },
        headingLink: {
            display: 'inline-flex'
        },
        heading: {
            fontSize: 'webLg',
            paddingTop: 3,
            paddingBottom: 3
        },
        headingAll: {
            fontSize: 'webMd',
            fontWeight: '500',
            lineHeight: '20px'
        },
        bgColorPadding: {
            padding: '1px'
        }
    },
    variants: {
        vertical: {
            list: {
                spacing: 3.5
            }
        },
        horizontal: {
            list: {
                display: 'flex',
                flexDirection: 'row',
                gap: '0.5rem'
            },
            listItem: {
                borderLeft: '1px solid',
                paddingLeft: 2
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        },
        menuItem: {
            container: {
                color: 'black'
            },
            wrapperStyles: {
                display: {base: 'flex'}
            },
            defaultListStyle: {
                display: {base: 'flex'}
            },
            heading: {
                padding: 0,
                textStyle: 'bodySmMedium'
            },
            list: {
                textStyle: 'labelXs',
                spacing: '10px'
            },
            badge: {
                textStyle: 'badge',
                marginLeft: {base: 1},
                padding: {base: 1},
                backgroundColor: 'backgroundPrimaryBrand',
                flexShrink: 0,
                alignSelf: 'flex-start',
                whiteSpace: 'nowrap'
            },
            /* SFCC-pulled mega-menu links (subcategory children rendered via
             * LinksList) reuse the same animated underline as the level-0 nav
             * triggers — see theme/components/project/list-menu.js
             * (listMenuTriggerLink). The `::before` line is content-width
             * (inline-block link, 100% width) and scales in from the left on
             * hover. `currentColor` keeps the line in sync with the inherited
             * text color so a future themed override only needs to set `color`.
             *
             * Applied to both the body links and the optional `All <Category>`
             * heading link so the entire SFCC link surface picks up the effect
             * regardless of whether the column has a clickable heading. */
            link: {
                position: 'relative',
                display: 'inline-block',
                _hover: {textDecoration: 'none'},
                sx: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        bottom: '-2px',
                        left: 0,
                        width: '100%',
                        height: '1px',
                        backgroundColor: 'currentColor',
                        transform: 'scaleX(0)',
                        transformOrigin: 'left center'
                    },
                    '&:hover::before': {
                        transform: 'scaleX(1)',
                        transition: 'transform 0.3s ease'
                    }
                }
            }
        }
    },
    defaultProps: {
        variant: 'vertical'
    }
}
